import React from "react"
import { Outlet, type RouteObject } from "react-router-dom"

import { PermissionGate } from "../../../../components/PermissionGate/PermissionGate.tsx"
import { RoutesPaths } from "../../../../constants/routes.ts"
import { lazyPage } from "../lazyPage.tsx"

const ProposalAddPage = lazyPage(
  () => import("../../../Proposals/ProposalAddPage/ProposalAddPage.tsx")
)
const ProposalEditPage = lazyPage(
  () => import("../../../Proposals/ProposalEditPage/ProposalEditPage.tsx")
)
const ProposalViewPage = lazyPage(
  () => import("../../../Proposals/ProposalViewPage/ProposalViewPage.tsx")
)
const ProposalsPage = lazyPage(() =>
  import("../../../Proposals/ProposalsPage/ProposalsPage.tsx").then((m) => ({
    default: m.ProposalsPage
  }))
)
const ProposalsLayout = lazyPage(() =>
  import("../../../Proposals/components/ProposalsLayout.tsx").then((m) => ({
    default: m.ProposalsLayout
  }))
)
export const proposalRoutes: RouteObject[] = [
  {
    element: (
      <PermissionGate paths={["leads.features.lead_proposal_approval"]}>
        <Outlet />
      </PermissionGate>
    ),
    children: [
      {
        path: `${RoutesPaths.proposal.add}`,
        element: <ProposalAddPage />
      },
      {
        path: `${RoutesPaths.proposal.edit(":id")}`,
        element: <ProposalEditPage />
      },
      {
        path: RoutesPaths.proposal.list,
        element: <ProposalsLayout />,
        children: [
          { index: true, element: <ProposalsPage /> },
          { path: ":id", element: <ProposalViewPage /> }
        ]
      }
    ]
  }
]
